// ARCHIVO GENERADO — no lo edites a mano.
// Lo escribe scripts/generate-version.js en cada build (prebuild / prestart).
export const APP_VERSION = '1.0.0';
export const APP_BUILD_ID = '1.0.0-1a2407e-muivblu6';
export const APP_BUILD_DATE = '2026-09-26T20:54:40.933Z';
